import React from 'react';

const RadioButton = ({ isChecked, label, disabled, onSelectionChange }) => {
  return (
    <div className="pure-radiobutton bus-triptype-radio" onClick={disabled? null: () => onSelectionChange(label, !isChecked)}>
      <input
        type="radio"
        className="radio"
        checked={isChecked}
        disabled={disabled}
      />
      <label htmlFor="label">{label}</label>
    </div>
  )
}

export default RadioButton
